<script setup>
import { computed } from "vue";
import { Medal } from "lucide-vue-next";
import { BRAND_LOGO_URL } from "@/shared/config/constants";
import { compact, fmt, usageDetailLine } from "@/shared/utils/format";
import MemberBadges from "@/features/leaderboard/components/MemberBadges.vue";

const props = defineProps({
  items: { type: Array, required: true },
  isCurrent: { type: Boolean, default: true },
  currentLabel: { type: String, default: "今日" },
});

// 桌面与移动同为三列横排，顺序 2-1-3（第一名居中且最大）
const ordered = computed(() => [props.items[1], props.items[0], props.items[2]].filter(Boolean));

function tagLabel(item) {
  if (item.rank === 1 && props.isCurrent) return `${props.currentLabel}榜首`;
  return `no.${item.rank}`;
}
</script>

<template>
  <section class="podium-section">
    <div class="container podium">
      <div v-for="item in ordered" :key="item.id" class="podium-col" :class="`p${item.rank}`">
        <div class="podium-card">
          <div class="podium-tag">
            <span class="only-desktop">{{ tagLabel(item) }}</span>
            <span class="only-mobile">no.{{ item.rank }}</span>
          </div>
          <a
            v-if="item.user?.profileUrl"
            class="podium-profile-link"
            :href="item.user.profileUrl"
            :aria-label="`查看 ${item.user?.displayName || '小能熊用户'} 的社区主页`"
          >
            <img class="podium-avatar" :src="item.user?.avatarUrl || BRAND_LOGO_URL" alt="" />
            <div class="podium-name">{{ item.user?.displayName || "小能熊用户" }}</div>
          </a>
          <template v-else>
            <img class="podium-avatar" :src="item.user?.avatarUrl || BRAND_LOGO_URL" alt="" />
            <div class="podium-name">{{ item.user?.displayName || "小能熊用户" }}</div>
          </template>
          <MemberBadges :memberships="item.user?.memberships" compact />
          <div class="podium-total">
            <span class="only-desktop">{{ fmt.format(item.totalTokens) }}</span>
            <span class="only-mobile">{{ compact.format(item.totalTokens) }}</span>
          </div>
          <div class="podium-detail">{{ usageDetailLine(item) }}</div>
        </div>
        <div class="podium-base" :aria-label="`${item.rank} 名奖牌`">
          <Medal class="podium-medal" :stroke-width="2.6" aria-hidden="true" />
        </div>
      </div>
    </div>
  </section>
</template>
